import { Box, Typography, Button, IconButton, Tooltip } from '@mui/material';
import { CloudUpload, Delete } from '@mui/icons-material';

export default function ScreenshotCapture({
  fileInputRef,
  screenshotFile,
  screenshotPreview,
  onFileChange,
  onRemoveScreenshot,
  disabled = false,
}) {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Attachment (optional)
      </Typography>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={onFileChange}
        aria-label="Attach screenshot"
        disabled={disabled}
      />

      {screenshotPreview ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 1.5,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            bgcolor: 'grey.50',
          }}
        >
          <Box
            component="img"
            src={screenshotPreview}
            alt="Screenshot preview"
            sx={{
              width: 60,
              height: 60,
              objectFit: 'cover',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'grey.300',
            }}
          />
          <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Typography variant="body2" fontWeight={600} noWrap>
              {screenshotFile?.name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {Math.round((screenshotFile?.size || 0) / 1024)} KB
            </Typography>
          </Box>
          <Tooltip title="Remove attachment">
            <IconButton
              aria-label="Remove attachment"
              color="error"
              size="small"
              onClick={onRemoveScreenshot}
              disabled={disabled}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ) : (
        <Button
          variant="outlined"
          startIcon={<CloudUpload />}
          onClick={() => fileInputRef.current?.click()}
          size="small"
          disabled={disabled}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Attach Screenshot
        </Button>
      )}
    </Box>
  );
}
